module.exports = __webpack_public_path__ + "static/discovery-1f6d28ec28c356091efb0071a16f3a4c.png";